import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "../lib/api";

export default function UploadButton({ label = "Fotoğraf Yükle", accept = "image/*", video = false, onUploaded }) {
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (video) {
      const ok = await new Promise((resolve) => {
        const url = URL.createObjectURL(file);
        const v = document.createElement("video");
        v.preload = "metadata";
        v.onloadedmetadata = () => {
          const d = v.duration;
          URL.revokeObjectURL(url);
          resolve(d <= 15.5);
        };
        v.onerror = () => resolve(true);
        v.src = url;
      });
      if (!ok) {
        toast.error("Video en fazla 15 saniye olabilir");
        e.target.value = "";
        return;
      }
    }
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/upload", fd);
      onUploaded(`${process.env.REACT_APP_BACKEND_URL}${r.data.url}`);
      toast.success("Dosya yüklendi");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={handle} data-testid={video ? "video-upload-input" : "photo-upload-input"} />
      <button type="button" data-testid={video ? "video-upload-btn" : "photo-upload-btn"} onClick={() => ref.current?.click()} disabled={loading} className="btn-ghost !py-2 text-xs">
        <Upload size={14} /> {loading ? "Yükleniyor..." : label}
      </button>
    </>
  );
}
